module.exports = __webpack_public_path__ + "assets/img/fastDownload.6cbc41fe.png";